const Action = {
  ADD: "add",
  UPDATE: "update",
  REMOVE: "remove",
  IGNORE: "ignore",
};

export { Action };
